"use client"

import React, {useEffect, useState} from 'react';
import Post2 from "@/components/common/post/Post2";
import {getFirstURISegment} from "@/utility/uriSegment.utility";
import Breadcrumbs from "@/components/common/BreadCrumb";
import PageHeader from "@/components/common/page-header";

function Page({params}) {
    const paths = [
        { name: "TRANG CHỦ", url: "/" },
        { name: "DỊCH VỤ CHÍNH" },
    ];
    const [url, setUrl] = useState(null);
    useEffect(() => {
        if (!params?.post) return;

        // Luôn lấy slug cuối để tránh trùng segment
        const finalUrl = getFirstURISegment() + "/" + params.post.split("/").pop();
        setUrl(finalUrl);
    }, [params.post]);

    return (
        <>
            <PageHeader title="Dịch vụ chính" />
            <div className="container-fluid" style={{marginTop: "20px"}}>
                <Breadcrumbs paths={paths}/>
            </div>
            {url ? <Post2 url={url}/> : ""}
        </>
    );
}

export default Page;
